import React, { useState, useEffect } from "react";
import { Input } from "antd"; // Ant Design Input
import axios from "axios";
import { SearchOutlined } from "@ant-design/icons";

const DelaySearch = ({ placeholder, onSearch, isDelay = true, ...props }) => {
  const [inputValue, setInputValue] = useState(); // State for input
  const [searchTerm, setSearchTerm] = useState(); // State for debounced search term

  // Handle input change, update inputValue state
  const handleInputChange = (e) => {
    // console.log(e.target.value);
    setInputValue(e.target.value);
  };

  // Debounce Effect: Update `searchTerm` after 0.5 seconds of no typing
  useEffect(() => {
    if (isDelay) {
      const delayDebounceFn = setTimeout(() => {
        setSearchTerm(inputValue); // Set the debounced value
      }, 1000); // 1 seconds delay

      return () => clearTimeout(delayDebounceFn); // Cleanup the timeout
    } else {
      setSearchTerm(inputValue); // Set the debounced value
    }
  }, [inputValue]);

  // Effect to trigger axios call when `searchTerm` changes
  useEffect(() => {
    onSearch(searchTerm);
  }, [searchTerm]); // Axios triggered when searchTerm changes

  return (
    <Input
      {...props}
      size="large"
      placeholder={placeholder}
      value={inputValue}
      allowClear
      onChange={handleInputChange}
      prefix={<SearchOutlined />}
    />
  );
};

export default DelaySearch;
